import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import SnowfallBackgroundStore from './store';

const styles = require('./index.less');

const SnowfallBackground = ({ store }) => {
  store.use();
  return <canvas ref={store.canvasRef} className={styles.snowCanvas} />;
};

export default wrapStore(SnowfallBackground, SnowfallBackgroundStore);
